import React from 'react';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import AccountStep from './Steps/AccountsStep/AccountsStepContainer';

const AccountsWorkflowView = ({ branch, workflowId }) => (
  <AdvWorkflow
    branch={branch}
    workflowId={workflowId}
    steps={[AccountStep]}
  />
);

AccountsWorkflowView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default AccountsWorkflowView;
